<template>
    <div style="height: 100%;">
        <div id="main" v-show="!rotaAninhada">
            <container-loader
                v-if="isLoading && !$store.getters.isLoading"
            />
            <div class="page">
                <div class="tipos-servicos vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">
                                {{ $t("tipoendereco") }}
                            </h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{
                                            isVenda ? $t("vendas") :
                                            $t("agro")
                                        }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{
                                            $t("tipoendereco")
                                        }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <button
                                v-if="!integracao && permissao.create"
                                class="save-btn"
                                type="button"
                                tag="button"
                                @click="
                                    $router.push({
                                        name: `${abrev}-tipoendereco-new`,
                                    })
                                "
                            >
                                {{ $t("adicionar") }}
                            </button>
                        </div>
                    </div>

                    <div class="search-and-filter">
                        <div class="search-bar">
                            <search-bar
                                :onSearch="debouncedOnSearch"
                            />
                        </div>

                        <div class="situacao-select">
                            <label v-text="$t('situacao')" />
                            <v-select
                                ref="situacaoInput"
                                class="is-100"
                                label="label"
                                :options="situacoes"
                                @input="onSituacaoChanged"
                                v-model="situacao"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template
                                    slot="selected-option"
                                    slot-scope="option"
                                >
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="no-options">{{
                                    $t("sem-resultados")
                                }}</template>
                            </v-select>
                        </div>
                    </div>

                    <div class="registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            :data="tiposEndereco"
                            class="data-table"
                            @sort="sortTable"
                            backend-sorting
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="
                                    f.key != 'excluir' ? $t(f.key) : ''
                                "
                                :width="f.width"
                                :class="{
                                    'excluir-field': f.key == 'excluir',
                                    'label-km': f.key == 'label',
                                }"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'descricao'">
                                    <router-link
                                        :to="{
                                            name: `${abrev}-tipoendereco-edit`,
                                            params: { id: props.row.id },
                                        }"
                                    >
                                        <pre>{{ props.row[f.key] }}</pre>
                                    </router-link>
                                </div>
                                <div v-else-if="f.key == 'tipo'">
                                    <pre>{{ props.row[f.key] }}</pre>
                                </div>
                                <div v-else-if="f.key == 'situacao'">
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-if="props.row[f.key] == 1"
                                        type="is-success"
                                        size="is-medium"
                                    >
                                        {{ $t("ativo") }}
                                    </b-tag>
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-else
                                        type="is-danger"
                                        size="is-medium"
                                    >
                                        {{ $t("inativo") }}
                                    </b-tag>
                                </div>
                                <div v-else-if="f.key == 'excluir'">
                                    <b-button
                                        v-if="permissao.update && !integracao"
                                        class="action-button"
                                        :type="
                                            props.row['situacao'] == 1
                                                ? 'is-danger'
                                                : 'is-success'
                                        "
                                        :icon-right="
                                            props.row['situacao'] == 1
                                                ? 'delete'
                                                : 'check'
                                        "
                                        @click="
                                            promptChangeSituacao(props.row)
                                        "
                                        v-tippy 
                                        :title="$t(
                                            props.row['situacao'] == 1
                                                ? 'desativar'
                                                : 'reativar'
                                        )"
                                    />
                                </div>
                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import ContainerLoader from "@/components/content/loader/ContainerLoader";
import TipoEnderecoService from "@/services/vendas/TipoEnderecoService";

export default {
    beforeRouteUpdate(to, from, next) {
        if (
            to.name.includes(`${this.abrev}-tipoendereco`) &&
            to.name != `${this.abrev}-tipoendereco-list`
        ) {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados();
            next();
        }
    },
    components: {
        ContainerLoader,
    },
    data() {
        return {
            integracao:
                this.$store.state.user.tabelasERPWebServer.includes("TIPOENDERECO"),
            tiposEndereco: [],
            situacoes: [
                { id: 2, label: "todos" },
                { id: 1, label: "ativos" },
                { id: 0, label: "inativos" },
            ],
            tipos: [
                { id: "E", label: "entrega" },
                { id: "C", label: "cobranca" },
            ],
            situacao: { id: 2, label: "todos" },
            tipo: { id: "E", label: "entrega" },
            service: new TipoEnderecoService(this.$http, this.$router),
            fields: [
                { key: "codigo", width: '10%', sortable: true, sortFn: null },
                { key: "descricao", width: null, sortable: true, sortFn: null },
                { key: "tipo", width: 80, sortable: true, sortFn: null },
                { key: "situacao", width: 80, sortable: true, sortFn: null },
                { key: "excluir", width: 20, sortable: false, sortFn: null },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            delete: null,
            queryFilter: "",
            column: "descricao",
            order: "asc",
            permissao: {},

            // @86308 - Rota dinâmica abreviando o contexto
            abrev: this.$route.meta.contexto.slice(0,3),
            isVenda: this.$route.meta.contexto == "vendas",
            isAgro: this.$route.meta.contexto == "agro",
        };
    },
    created() {
        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                "vendas",
                "clientes",
                "ven-tipoendereco"
            );
        }else if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0,4);
            this.permissao = this.hasPermissionAccess( 
                'agro', 
                'clientes', 
                'agro-tipoendereco'
            );
        }

        if (
            this.$route.name.includes(`${this.abrev}-tipoendereco`) &&
            this.$route.name != `${this.abrev}-tipoendereco-list`
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "tipoendereco" },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    methods: {
        onSearch(value) {
            this.queryFilter = value;
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.situacao = val
                ? this.situacoes.filter((v) => v.id == val.id)[0]
                : this.situacoes[0];
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.tiposEndereco = value;
                    this.isEmpty = this.tiposEndereco.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-load");
                    console.error("Erro ao carregar os tipos de endereço.");
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        findAll(column, order, page, limit, situacao, ...params) {
            if(this.isVenda) {
                return this.service
                .findAllVendas(column, order, page, limit, situacao, ...params);
            }else {
                return this.service
                .findAllAgro(column, order, page, limit, situacao, ...params);
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map((m) => {
                return {
                    id: m.id,
                    codigo: m.idtipoenderecoerp,
                    descricao: m.descricao,
                    tipo: m.tipo,
                    situacao: m.situacao,
                    excluir: "excluir",
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? "msg-confirmacao-desativacao-n"
                        : "msg-confirmacao-reativacao-n", 
                    { n: row.descricao }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.situacao == 1
                    ? "msg-erro-ao-desativar-tipoendereco"
                    : "msg-erro-ao-reativar-tipoendereco";

            let tempTipoEndereco = {
                idTipoEndereco: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };

            this.isLoading = true;

            this.updateSituacao(tempTipoEndereco)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.situacao == 1
                                ? "msg-sucesso-ao-reativar-tipoendereco"
                                : "msg-sucesso-ao-desativar-tipoendereco";
                        this.$root.showMessage("success", tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage(
                            "error",
                            "Erro ao atualizar status."
                        );
                    }
                })
                .catch((e) => {
                    console.error("Erro ao atualizar status.", e);
                    this.$root.showMessage("error", tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        updateSituacao(tipoEndereco) {
            if(this.isVenda) return this.service.updateSituacaoVendas(tipoEndereco);
            else return this.service.updateSituacaoAgro(tipoEndereco);
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
    min-height: calc(100% - 50px);
    position: relative;

    .page {
        position: relative;
        padding-left: 0;

        .table-tag {
            width: 5rem !important;
        }

        .tipos-servicos .search-and-filter {
            display: flex;
            justify-content: space-between;
            margin: 10px 0;

            .search-bar {
                width: 80%;
                padding-right: 10px;
            }
            .situacao-select {
                width: 30%;
                div {
                    height: 40px;
                }
            }
            .filter-bar {
                width: 31%;
            }
            @media (max-width: 760px) {
                .search-bar {
                    padding-right: 0;
                }
                .situacao-select {
                    width: 100%;
                }
            }
        }
    }
}
</style>
